export default __webpack_public_path__ + "145a8cf5851da57036b7ccc072f7f20c.png";